const initial = 0;

export default (state = initial, event) => {
  switch (event.type) {
    case 'ACTIVE-TAB':
      return (state = 1);
    case 'RESET-TAB':
      return (state = 0);
    default:
      return state;
  }
};
